import React from 'react';
import videoThumbnail from '../../../assets/images/home_screen/video_thumbnail.webp';
import whiteLogo from '../../../assets/images/home_screen/Logo_1_1.webp';
import GradientOutlineButton from '../../../components/atoms/GradientOutlineButton';
import CustomDialog from '../../../components/CustomDialog';
import { IoClose } from 'react-icons/io5';
import GradientButton from '../../../components/atoms/GradientButton';

const WhatWeOffer = () => {
  const [modalOpen, setModalOpen] = React.useState(false);

  return (
    <>
      <style>
        {`
          li {
          font-size:18px
          }
          @media (min-width: 1536px) {
      li {
        font-size: 22px;
      }
    }
        `}
      </style>
      <div
        id="about_us"
        className="flex justify-center flex-col md:flex-row max-w-[1200px] m-auto px-4 md:px-10 py-14 gap-10 md:gap-20 relative z-10"
      >
        <div className="flex flex-col gap-3 flex-1">
          <img
            src={whiteLogo}
            alt="color-logo"
            className="w-[200px] xl:w-[225px]"
          />
          <h3 className="text-3xl font-bold text-primary">
            Guidepost Pediatric Therapies <br /> and Educational Services
          </h3>
          <p className="text-secondary text-lg">
            At Guidepost Pediatrics, we are passionate about helping every child
            reach their full potential, using state-of-the-art modalities in
            pediatric occupational, physical, and speech therapy. The Guidepost
            team, composed of dedicated highly qualified professionals
            specialize in pediatric therapies and educational support. We offer
            a range of services designed to address your child’s needs, bringing
            lasting changes to their quality of life. We offer a warm and
            welcoming environment with therapeutic equipment and sensory gym
            where neurodivergent children feel right at home.
          </p>
        </div>
        <div className="flex-1 flex flex-col gap-4">
          <img
            onClick={() => setModalOpen(true)}
            src={videoThumbnail}
            alt="video_thumbnail"
            className="sm:max-w-[410px] w-full cursor-pointer"
          />
          <div className="font-semibold text-[#4A494A] text-lg 2xl:text-[2xl] w-full md:max-w-[390px] leading-6">
            <p className="font-bold text-[18px] 2xl:text-[22px]">
              We offer a full suite of Pediatric Therapies, including
            </p>
            <ul className="list-disc list-outside ml-8">
              <li>Pediatric Feeding Therapy</li>
              <li>Pediatric Physical Therapy (PT)</li>
              <li>Occupational Therapy (OT)</li>
              <li>Speech Therapy (SLP or ST)</li>
              <li>Dyslexia Testing and Intervention Services</li>
              <li>Behavioral Therapy</li>
              <li>Educational Services specially tailored to your family.</li>
            </ul>
          </div>
          <div>
            <p className="text-pink text-[22px] 2xl:text-[25px] relative leading-6 italic font-semibold">
              "Guidepost Pediatrics is a fantastic addition to our community.
              Susan, the owner, has done a remarkable job bringing in highly
              qualified specialists to Alaska in an area where we have
              historically lacked services."
            </p>
          </div>
          <div className="flex gap-4 mt-5">
            <GradientOutlineButton
              text="About Us"
              navigateTo="/about"
              isDark={false}
              width={'w-fit'}
            />
            <GradientButton text={'Schedule Now'} navigateTo="/contact" />
          </div>
        </div>
      </div>

      <CustomDialog open={modalOpen} setOpen={setModalOpen}>
        <div className="w-full h-full flex items-center justify-center relative p-4">
          {/* Close Button - Now relative to iframe container */}
          <IoClose
            onClick={() => setModalOpen(false)}
            className="absolute right-0 -top-4 md:-right-4 text-white text-4xl cursor-pointer z-50"
          />

          <iframe
            src="https://www.youtube.com/embed/-RzOQKD0iPg?autoplay=1&rel=0&showinfo=0&modestbranding=1"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="w-[95vw] h-[400px] md:w-[84vw] md:h-[60vh] xl:w-[80vw] xl:h-[71vh]  3xl:h-[80vh] 4xl:h-[90vh] rounded-md shadow-lg"
          />
        </div>
      </CustomDialog>
    </>
  );
};

export default WhatWeOffer;
